/**
 * Database Service for saving form data to AWS RDS MySQL
 */

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' 
    ? window.location.origin 
    : 'http://localhost:3001');
/**
 * Save form data to the database
 * @param {Object} formData - The form data to save
 * @returns {Promise<Object>} - Response with success status and message
 */
export const saveFormData = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/api/save-form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ formData }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to save form data');
    }
    
    return {
      success: true,
      message: data.message || 'Form data saved successfully',
      id: data.id
    };
  } catch (error) {
    console.error('Error saving form data:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while saving form data',
    };
  }
};
